import React, { useState, useEffect } from "react"

import StarIcon from "../assets/icons/star.svg";

import './GitHubStar.scss';

function GitHubStar({repo = "okteto/okteto"}) {
  const [starsCount, setStarsCount] = useState(0);

  useEffect(() => {
    fetch(`https://api.github.com/repos/${repo}`)
      .then(response => response.json())
      .then(resultData => {
        setStarsCount(resultData.stargazers_count)
      })
  }, [repo])

  return (
    <div className="GitHubStar">
      <span className="GitHubStarTitle"><StarIcon />Star</span>
      <span className="GitHubStarAmount">{starsCount}</span>
    </div>
  );
}

export default GitHubStar;
